@use 'sass:map';
@use 'common/assets/scss/global' as *;
@import '@fortawesome/fontawesome-svg-core/styles.css';

@keyframes shimmer {
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: -100% 0;
  }
}

@mixin favorite {
  border-radius: 10px;
  padding: 12px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  row-gap: 4px;
  width: 100%;
  height: 100%;
  min-height: 100px;

  > .actions {
    @include actions;

    @media (hover: none) or (pointer: coarse) {
      inset: 0 -2px;

      > .action-delete {
        right: 6 + 2px;
      }
    }
  }

  > .icon {
    flex: 0 0 auto;
    height: 30px;
    width: 30px;
    color: var(--#{$prefix}service, $black);
  }

  > a {
    flex: 0 0 auto;
    @include unstyled-link;
    font-size: var(--#{$prefix}font-size-xs);

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 10px;
    }

    &:focus-visible {
      outline: none;
    }
  }

  > .tag-category {
    flex: 0 0 auto;
  }

  &:hover,
  &:has(:focus-visible) {
    outline: 2px solid var(--#{$prefix}primary);
    box-shadow: var(--#{$prefix}shadow-hover) HEXToRGBA(var(--#{$prefix}primary), 0.2);
  }

  &:has(.actions:not(.disabled)) {
    &:hover,
    &:has(:focus-visible) {
      outline: none;
      box-shadow: var(--#{$prefix}shadow-strong) HEXToRGBA($black, 0.1);
    }
  }
}

.favorite-layout {
  > .header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;

    > h2 {
      margin: 0;
      color: var(--#{$prefix}primary);
    }

    > .actions {
      display: flex;
      flex-wrap: wrap;
      flex-grow: 1;
      justify-content: end;
      gap: 6px;
    }
  }

  > ul {
    @include unstyled-list;

    > li {
      > .header {
        color: var(--#{$prefix}basic-black-lighter);
        display: block;
        font-weight: 500;
        font-style: italic;
        border-bottom: 1px solid var(--#{$prefix}stroke);
        margin: 12px 0;
        padding: 4px 10px;

        > span.skeleton {
          display: block;
          width: 70px;
          height: 1em;
          border-radius: 50px;
          background: linear-gradient(90deg, #e9e9e9 30%, #f6f6f6 50%, #e9e9e9 70%);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite linear;
        }
      }

      > ul {
        @include unstyled-list;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
        grid-auto-rows: 1fr;
        gap: 12px;

        > li {
          &:first-child > .favorite > .actions > .action-back,
          &:last-child > .favorite > .actions > .action-next {
            display: none;
          }

          > .favorite {
            @include favorite;

            @each $type, $values in $categories {
              @if $type == category-default {
                --#{$prefix}service: var(--#{$prefix}#{$type});
                --#{$prefix}service-hover: var(--#{$prefix}#{$type}-hover);
                --#{$prefix}service-hover-shadow: var(--#{$prefix}#{$type}-hover-shadow);
              } @else {
                &.#{$type} {
                  --#{$prefix}service: var(--#{$prefix}#{$type});
                  --#{$prefix}service-hover: var(--#{$prefix}#{$type}-hover);
                  --#{$prefix}service-hover-shadow: var(--#{$prefix}#{$type}-hover-shadow);
                }
              }
            }
          }

          &.skeleton {
            height: 100px;
            border-radius: 10px;
            background: linear-gradient(90deg, #e9e9e9 30%, #f6f6f6 50%, #e9e9e9 70%);
            background-size: 200% 100%;
            animation: shimmer 1.5s infinite linear;
          }
        }
      }

      > .empty {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        min-height: 100px;

        > .icon {
          font-size: 38px;
          margin-bottom: 14px;
          color: var(--#{$prefix}basic-black);
          opacity: 0.1;
        }

        > .text {
          display: flex;
          flex-direction: column;
          text-align: center;
          font-size: var(--#{$prefix}font-size-xs);

          > .large {
            font-size: var(--#{$prefix}font-size-sm);
            font-weight: bold;
            letter-spacing: -0.15px;
          }
        }
      }
    }
  }

  @media (width >= map.get($grid-breakpoints, md)) {
    > ul > li > ul {
      grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
      gap: 16px;
    }
  }
}
